import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={20} height={15} fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#989898" d="M0-.2h20v3H0zM0 6.15h20v3H0zM0 12.2h20v3H0z" /></svg>;
}
export default SvgComponent;